/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Hero_TitleInputs */

const en_downloads_hero_title = /** @type {(inputs: Downloads_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Listening`)
};

const es_downloads_hero_title = /** @type {(inputs: Downloads_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar Listening`)
};

/**
* | output |
* | --- |
* | "Download Listening" |
*
* @param {Downloads_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_hero_title = /** @type {((inputs?: Downloads_Hero_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Hero_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_hero_title(inputs)
	return en_downloads_hero_title(inputs)
});